import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import * as actions from './actions';
import { AppConfiguration } from 'config';
import { genericGetRequest, genericGetRequest_2 } from 'helpers/sf_backend_helper';
import { bsh_getAdminUserDetails } from 'helpers/sf_browser_storage_helper';


function* fetchVacuumStatus() {
    try {
        const header = {
            Authorization: bsh_getAdminUserDetails()?.token
        };
        const response = yield call(genericGetRequest, `${AppConfiguration.BACKEND_URL}/api/v1/postgres_autovacuum_status`, {}, header);
        yield put(actions.fetchVacuumStatusSuccess(response));
    } catch (error) {
        yield put(actions.fetchVacuumStatusFailure(error.message));
    }
}

function* fetchRdsEvents(action) {
    try {
        const header = {
            Authorization: bsh_getAdminUserDetails()?.token
        };
        // genericGetRequest_2 keeps `additional_data`, which carries the
        // lookahead pagination metadata the grid pages with.
        const response = yield call(genericGetRequest_2, `${AppConfiguration.BACKEND_URL}/api/v1/rds_events`, action.payload, header);
        yield put(actions.fetchRdsEventsSuccess(response));
    } catch (error) {
        yield put(actions.fetchRdsEventsFailure(error.message));
    }
}


function* RdsMonitorSaga() {
    yield takeLatest(types.FETCH_VACUUM_STATUS, fetchVacuumStatus);
    yield takeLatest(types.FETCH_RDS_EVENTS, fetchRdsEvents);
}

export default RdsMonitorSaga;